
export const useCase = {
  title: "Kinek szól?",
  description: "Fedezd fel, hogyan használhatják az alkotók a platformot",
  addButton: "Használati eset hozzáadása",
  name: "Cím",
  description_field: "Leírás",
  icon: "Ikon",
  image: "Kép",
  actions: "Műveletek",
  edit: "Szerkesztés",
  delete: "Törlés",
  success: {
    create: "Használati eset sikeresen létrehozva",
    update: "Használati eset sikeresen frissítve",
    delete: "Használati eset sikeresen törölve"
  },
  errors: {
    create: "Nem sikerült létrehozni a használati esetet",
    update: "Nem sikerült frissíteni a használati esetet",
    delete: "Nem sikerült törölni a használati esetet"
  }
};
